import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=5183ff10&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183ff10",
  null
  
)

export default component.exports